export type SortOrder = "asc" | "desc";

/** Paging facts every list endpoint echoes back alongside its rows. */
export interface PaginationMeta {
  total: number;
  offset: number;
  limit: number;
  hasMore: boolean;
}

/** The response shape every list endpoint returns. */
export interface PaginatedResponse<T> {
  data: T[];
  meta: PaginationMeta;
}

/** Query string every list endpoint accepts. `sortBy` is narrowed per endpoint. */
export interface PaginatedRequest {
  offset?: number;
  limit?: number;
  search?: string;
  sortOrder?: SortOrder;
}

/**
 * Drops `undefined` and empty values so they never reach the wire — the backend's validation
 * pipe rejects `?search=` as a present-but-empty param, and an absent one is what we mean.
 */
export const toSearchParams = (params: Record<string, unknown>): Record<string, string> =>
  Object.fromEntries(
    Object.entries(params)
      .filter(([, value]) => value !== undefined && value !== null && value !== "")
      .map(([key, value]) => [key, String(value)]),
  );
